var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDocumentPlaceholder64(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.5 32.5v-3a4 4 0 00-4-4h-8a4 4 0 01-4-4v-8a4 4 0 00-4-4h-11a4 4 0 00-4 4v19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5 28.5v22a4 4 0 004 4h27a4 4 0 004-4v-24h0",
    strokeDasharray: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.5 31.5v-2.686a8 8 0 00-2.343-5.657L35.843 11.843A8 8 0 0030.186 9.5H20.5h0"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentPlaceholder64);
export default __webpack_public_path__ + "static/media/document-placeholder-64.f50edc99.svg";
export { ForwardRef as ReactComponent };